// Keys are translated from enUS
export * from "./arSD.mjs";
export * from "./beBY.mjs";
export * from "./bgBG.mjs";
export * from "./bnBD.mjs";
export * from "./csCZ.mjs";
export * from "./caES.mjs";
export * from "./daDK.mjs";
export * from "./deDE.mjs";
export * from "./elGR.mjs";
export * from "./enUS.mjs";
export * from "./esES.mjs";
export * from "./faIR.mjs";
export * from "./fiFI.mjs";
export * from "./frFR.mjs";
export * from "./heIL.mjs";
export * from "./huHU.mjs";
export * from "./hyAM.mjs";
export * from "./itIT.mjs";
export * from "./jaJP.mjs";
export * from "./koKR.mjs";
export * from "./nbNO.mjs";
export * from "./nlNL.mjs";
export * from "./nnNO.mjs";
export * from "./plPL.mjs";
export * from "./ptBR.mjs";
export * from "./roRO.mjs";
export * from "./ruRU.mjs";
export * from "./skSK.mjs";
export * from "./svSE.mjs";
export * from "./trTR.mjs";
export * from "./ukUA.mjs";
export * from "./urPK.mjs";
export * from "./viVN.mjs";
export * from "./zhCN.mjs";
export * from "./zhTW.mjs";
export * from "./hrHR.mjs";
export * from "./ptPT.mjs";
export * from "./zhHK.mjs";
export * from "./isIS.mjs";
export * from "./idID.mjs";